import gql from "graphql-tag";

export const GET_ALL_COUNTRIES = gql`
  query {
    geoCountrys(first: 100000) {
      edges {
        node {
          countryId
          name
        }
      }
    }
  }
`;
